import * as ErrorMessages from './errorMessages.js';
import { isWebUri } from 'valid-url';

export const required = (text) => {
  if (text) {
    return null;
  } else {
    return ErrorMessages.isRequired;
  }
};

export const mustMatch = (field, fieldName) => {
  return (text, state) => {
    return state[field] === text ? null : ErrorMessages.mustMatch(fieldName);
  };
};

export const minLength = (length) => {
  return (text) => {
    return text.length >= length ? null : ErrorMessages.minLength(length);
  };
};

export const minValue = (minValue) => {
  return (text) => {
    return Number(text)>=minValue ? null : ErrorMessages.minValue(minValue);
  };
};

export const maxValue = (maxValue) => {
  return (text) => {
    return Number(text)<=maxValue ? null : ErrorMessages.maxValue(maxValue);
  };
};


export const positiveInt = (text) => {
  if (text.match(/^[0-9]+$/) != null && Number(text)!==0) {
    return null;
  } else {
    return ErrorMessages.isPositiveInt;
  }
};


export const URL = (text) => {
  if (isWebUri(text)) {
    return null;
  } else {
    return ErrorMessages.isURL;
  }
};

// export const numeric = (text) => {
//   return (text) => {
//     return (text.match(/^[0-9]+$/) != null) ? null : ErrorMessages.isNumeric;
//   };
// };
